import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex flex-col my-10" }
const _hoisted_2 = { class: "flex w-full" }
const _hoisted_3 = { class: "w-full flex flex-col pl-3 justify-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-sm" }, "OUR COMPANY’S PERSONALITY", -1)
const _hoisted_5 = { class: "text-xl font-black text-white" }
const _hoisted_6 = { class: "flex flex-col justify-between pr-4" }
const _hoisted_7 = {
  id: "share_ebp",
  class: "p-auto"
}
const _hoisted_8 = {
  id: "ebp_modal",
  class: "-mb-4 p-auto"
}
const _hoisted_9 = {
  key: 1,
  class: "flex flex-wrap text-sm justify-center shadow-sm rounded-b-xl p-3 mx-7 gap-5 z-0"
}
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col items-center p-2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Survey Period", -1)
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Survey Sample", -1)
const _hoisted_14 = {
  key: 2,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Departments", -1)
const _hoisted_16 = {
  key: 3,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Tags", -1)
const _hoisted_18 = { class: "flex flex-col my-10 px-2" }
const _hoisted_19 = {
  key: 0,
  id: "lebp",
  class: "flex shadow-base rounded-xl w-full z-10"
}
const _hoisted_20 = { class: "w-full p-5 flex flex-col space-y-4" }
const _hoisted_21 = { class: "text-base flex justify-between items-center gap-3" }
const _hoisted_22 = {
  id: "share_lebp",
  class: "p-auto"
}
const _hoisted_23 = { class: "flex flex-col gap-4" }
const _hoisted_24 = { class: "text-xl font-black" }
const _hoisted_25 = {
  key: 1,
  class: "flex flex-wrap text-sm justify-center shadow-sm rounded-b-xl p-3 mx-7 gap-5 z-0"
}
const _hoisted_26 = {
  key: 0,
  class: "flex flex-col items-center p-2"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Survey Period", -1)
const _hoisted_28 = {
  key: 1,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Strengths", -1)
const _hoisted_30 = {
  key: 2,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Weaknesses", -1)
const _hoisted_32 = {
  key: 3,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "Departments", -1)
const _hoisted_34 = {
  key: 4,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "Tags", -1)
const _hoisted_36 = { class: "flex flex-col my-10 px-2" }
const _hoisted_37 = {
  key: 0,
  id: "ebm",
  class: "flex shadow-base rounded-xl w-full z-10"
}
const _hoisted_38 = { class: "w-full p-5 flex flex-col space-y-4" }
const _hoisted_39 = { class: "text-base flex justify-between items-center gap-3" }
const _hoisted_40 = {
  id: "share_ebm",
  class: "p-auto"
}
const _hoisted_41 = { class: "flex flex-col gap-4" }
const _hoisted_42 = { class: "text-xl font-black" }
const _hoisted_43 = {
  key: 1,
  class: "flex flex-wrap text-sm justify-center shadow-sm rounded-b-xl p-3 mx-7 gap-5 z-0"
}
const _hoisted_44 = {
  key: 0,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, "Survey Period", -1)
const _hoisted_46 = {
  key: 1,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, "Strengths", -1)
const _hoisted_48 = {
  key: 2,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, "Weaknesses", -1)
const _hoisted_50 = {
  key: 3,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", null, "Departments", -1)
const _hoisted_52 = {
  key: 4,
  class: "flex flex-col items-center max-w-[250px] p-2"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", null, "Tags", -1)
const _hoisted_54 = { class: "w-full flex flex-col pl-1 justify-center" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-sm" }, "OUR COMPANY’S PERSONALITY", -1)
const _hoisted_56 = { class: "text-xl font-black text-white" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "workbean-share mr-3" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "workbean-share mr-3" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "workbean-share mr-3" }, null, -1)
const _hoisted_61 = {
  key: 2,
  class: "m-auto my-10 w-full text-center text-gray-100 font-bold"
}

import { computed, onMounted } from "vue"
  import { useCompanyStore } from "@/store/company"
  import { useResourcesStore } from "@/store/resources"
  import { useRoute } from "vue-router"
  import { caretDownOutline, shareSocialOutline, copy } from "ionicons/icons"
  import { IonIcon } from "@ionic/vue"
  import { find } from "lodash"
  import { toastController } from "@ionic/core"
  import { record } from "@/utils/analytics"

  import EmployeeReviews from "@/components/workbean-page/culture/EmployeeReviews.vue"
  import CultureStories from "@/components/workbean-page/culture/CultureStories.vue"
  import BottomModal from "@/components/template/BottomModal.vue"
  import EbpCard from "@/components/workbean-page/culture/EbpImage.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CulturePage',
  setup(__props) {

  const store = useCompanyStore()
  const resourcesStore = useResourcesStore()
  const route = useRoute()

  const companyDetails = computed(() => store.companyDetails)
  const ebpList = computed(() => resourcesStore.ebp)
  const companyEbp = computed(() => companyDetails.value.insight.ebp || { id: "" })
  const companyLebp = computed(() => companyDetails.value.insight.lebp || { brand_scores: [] })
  const companyEbm = computed(() => companyDetails.value.insight.ebm || { brand_scores: [] })
  const ebpDetailsVisibility = computed(() => companyDetails.value.insight.ebp_details_visibility || [])
  const ebpDetails = computed(() => companyDetails.value.insight.ebp_details)
  const lebpDetailsVisibility = computed(() => companyDetails.value.insight.lebp_details_visibility || [])
  const lebpDetails = computed(() => companyDetails.value.insight.lebp_details)
  const ebmDetailsVisibility = computed(() => companyDetails.value.insight.ebm_details_visibility || [])
  const ebmDetails = computed(() => companyDetails.value.insight.ebm_details)
  const ebpObject = computed(() => {
    const objectFound = find(ebpList.value, { id: companyEbp.value.id })
    if (objectFound) {
      return {
        label: objectFound.name,
        color: objectFound.color,
        description: objectFound.description.full,
        shortDescription: objectFound.description.peak,
      }
    } else return undefined
  })
  const storiesData = computed(() => {
    if (companyDetails.value.story) {
      return companyDetails.value.story.map((val: any) => {
        return {
          description: val.description,
          title: val.title,
          video: val.link,
        }
      })
    }
    return []
  })
  const shareEbpOptions = ["Share to LinkedIn", "Share to Facebook", "Copy URL"]

  /**
   * get window location
   */
  const getLocation = () => window.location.toString()

  /**
   * Share function
   * share
   */
  const copyUrl = async (type?: string) => {
    navigator.clipboard.writeText(getLocation().includes(`#${type || "ebp"}`) ? getLocation() : `${getLocation()}#${type || "ebp"}`)
    const toast = await toastController.create({
      message: `${type || "ebp"} link copied to clipboard!`,
      duration: 3000,
      position: "top",
      color: "info",
    })
    await toast.present()
  }
  onMounted(() => {
    record({
      event: "CompanyViewPage",
      attributes: {
        link: route.fullPath,
        company_id: companyDetails.value.company_id,
      },
    })
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (companyDetails.value.subscription !== 'Free' && companyEbp.value && companyEbp.value.id && companyEbp.value.id.length > 0 && ebpObject.value)
        ? (_openBlock(), _createBlock(EbpCard, {
            key: 0,
            id: "ebp",
            data: ebpObject.value,
            class: "pl-3 pt-5 py-5 z-10"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(ebpObject.value.label), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", _hoisted_7, [
                    _createVNode(_unref(IonIcon), {
                      class: "text-3xl text-white",
                      icon: _unref(shareSocialOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _createElementVNode("button", _hoisted_8, [
                    _createVNode(_unref(IonIcon), {
                      class: "text-3xl text-white",
                      icon: _unref(caretDownOutline)
                    }, null, 8, ["icon"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["data"]))
        : _createCommentVNode("", true),
      (ebpDetailsVisibility.value && ebpDetailsVisibility.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (ebpDetailsVisibility.value.includes('period'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(ebpDetails.value?.period), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (ebpDetailsVisibility.value.includes('population'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(ebpDetails.value?.population) + "% of employees", 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (ebpDetailsVisibility.value.includes('departments'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(ebpDetails.value?.departments?.join(", ") || "N/A"), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (ebpDetailsVisibility.value.includes('tags'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(ebpDetails.value?.tags?.join(", ") || "N/A"), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_18, [
      (companyLebp.value && companyLebp.value.brand_scores && companyLebp.value.brand_scores.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h2", _hoisted_21, [
                _createTextVNode(_toDisplayString(companyDetails.value.name.trim()) + "'" + _toDisplayString(companyDetails.value.name.trim().endsWith("s") ? "" : "s") + " Leadership Employer Brand Perception ", 1),
                _createElementVNode("button", _hoisted_22, [
                  _createVNode(_unref(IonIcon), {
                    class: "text-3xl",
                    icon: _unref(shareSocialOutline)
                  }, null, 8, ["icon"])
                ])
              ]),
              _createElementVNode("ul", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyLebp.value.brand_scores.filter((item) => item.score > 0), (lebp, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${index}_lebp`
                  }, [
                    _createElementVNode("h2", _hoisted_24, _toDisplayString(lebp.name), 1)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (lebpDetailsVisibility.value && lebpDetailsVisibility.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (lebpDetailsVisibility.value.includes('period'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(lebpDetails.value?.period), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (lebpDetailsVisibility.value.includes('strengths'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(lebpDetails.value?.strengths?.join(", ")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (lebpDetailsVisibility.value.includes('weaknesses'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(lebpDetails.value?.weaknesses?.join(", ")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (lebpDetailsVisibility.value.includes('departments'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(lebpDetails.value?.departments?.join(", ") || "N/A"), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (lebpDetailsVisibility.value.includes('tags'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(lebpDetails.value?.tags?.join(", ") || "N/A"), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_36, [
      (companyEbm.value && companyEbm.value.brand_scores && companyEbm.value.brand_scores.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("h2", _hoisted_39, [
                _createTextVNode(_toDisplayString(companyDetails.value.name.trim()) + "'" + _toDisplayString(companyDetails.value.name.trim().endsWith("s") ? "" : "s") + " Employer Brand Matrix ", 1),
                _createElementVNode("button", _hoisted_40, [
                  _createVNode(_unref(IonIcon), {
                    class: "text-3xl",
                    icon: _unref(shareSocialOutline)
                  }, null, 8, ["icon"])
                ])
              ]),
              _createElementVNode("ul", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyEbm.value.brand_scores.filter((item) => item.score > 0), (ebm, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${index}_ebm`
                  }, [
                    _createElementVNode("h2", _hoisted_42, _toDisplayString(ebm.name), 1)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (ebmDetailsVisibility.value && ebmDetailsVisibility.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            (ebmDetailsVisibility.value.includes('period'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(ebmDetails.value?.period), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (ebmDetailsVisibility.value.includes('strengths'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(ebmDetails.value?.strengths?.join(", ")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (ebmDetailsVisibility.value.includes('weaknesses'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(ebmDetails.value?.weaknesses?.join(", ")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (ebmDetailsVisibility.value.includes('departments'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(ebmDetails.value?.departments?.join(", ") || "N/A"), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (ebmDetailsVisibility.value.includes('tags'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _hoisted_53,
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(ebmDetails.value?.tags?.join(", ") || "N/A"), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(BottomModal, {
      type: "ebp_modal",
      style: _normalizeStyle(`--ion-background-color: ${ebpObject.value?.color}`)
    }, {
      default: _withCtx(() => [
        _createVNode(EbpCard, { data: ebpObject.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("h2", _hoisted_56, _toDisplayString(ebpObject.value?.label), 1)
            ])
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("p", {
          class: "text-white border-t-1 border-white pt-5",
          innerHTML: ebpObject.value?.description
        }, null, 8, _hoisted_57)
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode(BottomModal, { type: "share_ebp" }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(shareEbpOptions, (shareOption, index) => {
          return _createElementVNode("div", {
            key: `${index}_id`,
            class: "my-3 text-center"
          }, [
            (index === 2)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 0,
                  expand: "block",
                  color: "white",
                  class: "normal-case",
                  style: { color: 'inherit' },
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (copyUrl('ebp')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      class: "text-xl mr-3",
                      icon: _unref(copy)
                    }, null, 8, ["icon"]),
                    _createTextVNode(_toDisplayString(shareOption), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_ShareNetwork, {
                  key: 1,
                  network: index == 0 ? 'linkedin' : 'facebook',
                  url: `${getLocation()}${getLocation().includes('\#ebp') ? '' : '\#ebp'}`,
                  description: `${ebpObject.value?.shortDescription}`,
                  title: `${companyDetails.value.name.trim()}'${companyDetails.value.name.trim().endsWith('s') ? '' : 's'} Employer Brand Personality - Workbean`,
                  hashtags: "workbean,employer_brand_personality,"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      color: "white",
                      class: "normal-case",
                      style: { color: 'inherit' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_58,
                        _createTextVNode(_toDisplayString(shareOption), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["network", "url", "description", "title"]))
          ])
        }), 64))
      ]),
      _: 1
    }),
    _createVNode(BottomModal, { type: "share_lebp" }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(shareEbpOptions, (shareOption, index) => {
          return _createElementVNode("div", {
            key: `${index}_id`,
            class: "my-3 text-center"
          }, [
            (index === 2)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 0,
                  expand: "block",
                  color: "white",
                  class: "normal-case",
                  style: { color: 'inherit' },
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (copyUrl('lebp')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      class: "text-xl mr-3",
                      icon: _unref(copy)
                    }, null, 8, ["icon"]),
                    _createTextVNode(_toDisplayString(shareOption), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_ShareNetwork, {
                  key: 1,
                  network: index == 0 ? 'linkedin' : 'facebook',
                  url: `${getLocation()}${getLocation().includes('\#lebp') ? '' : '\#lebp'}`,
                  description: `Leader’s perception of the company's employer brand.`,
                  title: `${companyDetails.value.name.trim()}'${companyDetails.value.name.trim().endsWith('s') ? '' : 's'} Leadership Employer Brand Perception - Workbean`,
                  hashtags: "workbean,leadership_employer_brand_perception,"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      color: "white",
                      class: "normal-case",
                      style: { color: 'inherit' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_59,
                        _createTextVNode(_toDisplayString(shareOption), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["network", "url", "description", "title"]))
          ])
        }), 64))
      ]),
      _: 1
    }),
    _createVNode(BottomModal, { type: "share_ebm" }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(shareEbpOptions, (shareOption, index) => {
          return _createElementVNode("div", {
            key: `${index}_id`,
            class: "my-3 text-center"
          }, [
            (index === 2)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 0,
                  expand: "block",
                  color: "white",
                  class: "normal-case",
                  style: { color: 'inherit' },
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (copyUrl('ebm')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      class: "text-xl mr-3",
                      icon: _unref(copy)
                    }, null, 8, ["icon"]),
                    _createTextVNode(_toDisplayString(shareOption), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_ShareNetwork, {
                  key: 1,
                  network: index == 0 ? 'linkedin' : 'facebook',
                  url: `${getLocation()}${getLocation().includes('\#ebm') ? '' : '\#ebm'}`,
                  description: `Employees' perception on 20 different employer brand facets.`,
                  title: `${companyDetails.value.name.trim()}'${companyDetails.value.name.trim().endsWith('s') ? '' : 's'} Employer Brand Matrix - Workbean`,
                  hashtags: "workbean,employer_brand_matrix,"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      color: "white",
                      class: "normal-case",
                      style: { color: 'inherit' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_60,
                        _createTextVNode(_toDisplayString(shareOption), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["network", "url", "description", "title"]))
          ])
        }), 64))
      ]),
      _: 1
    }),
    (storiesData.value && storiesData.value.length)
      ? (_openBlock(), _createBlock(CultureStories, {
          key: 0,
          "culture-data": storiesData.value,
          "company-data": { name: companyDetails.value.name, image: companyDetails.value.logo }
        }, null, 8, ["culture-data", "company-data"]))
      : _createCommentVNode("", true),
    (companyDetails.value.testimonial && companyDetails.value.testimonial.length)
      ? (_openBlock(), _createBlock(EmployeeReviews, {
          key: 1,
          reviews: companyDetails.value.testimonial,
          "company-name": companyDetails.value.name
        }, null, 8, ["reviews", "company-name"]))
      : _createCommentVNode("", true),
    (!companyEbp.value.id && companyEbp.value.id.length === 0 && storiesData.value && storiesData.value.length === 0 && companyDetails.value.testimonial && companyDetails.value.testimonial.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_61, " No culture data yet "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})